import noop from "lodash/noop";
import React from "react";
import WorkOrderCard from "./WorkOrderCard";

export default function MockWorkOrderCardContainer({
  applicationContext,
  expandedWorkOrders,
  layoutSettingData,
  workOrder,
}) {
  return (
    <WorkOrderCard
      applicationContext={applicationContext}
      expanded={expandedWorkOrders.includes(workOrder.id)}
      layoutSettingData={layoutSettingData}
      onToggleExpandWorkOrder={noop}
      workOrder={workOrder}
    />
  );
}
